import { Type } from "class-transformer";
import { PayrollCalendarViewDayDto } from "@/core/features/payrolls/payroll-calendar-view-day.dto";
import { PayrollCalendarViewWarningDto } from "@/core/features/payrolls/payroll-calendar-view-warning.dto";
import { PayrollPendingWorksheetsSummaryDto } from "@/core/features/payrolls/payroll-pending-worksheets-summary.dto";

export class PayrollCalendarViewDto {
  @Type(() => PayrollCalendarViewDayDto)
  days: PayrollCalendarViewDayDto[];

  @Type(() => PayrollCalendarViewWarningDto)
  warnings: PayrollCalendarViewWarningDto[];

  @Type(() => PayrollPendingWorksheetsSummaryDto)
  pendingWorksheets: PayrollPendingWorksheetsSummaryDto;
}
